exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*,:after,:before{-webkit-box-sizing:inherit;box-sizing:inherit;margin:0;padding:0}html{color:#222;font-weight:400;font-size:16px;font-family:Roboto,sans-serif;line-height:1.75;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased}._1fqjz{display:-webkit-box;display:-ms-flexbox;display:flex;min-height:100vh;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._2LtWy{background:#909dab;margin-bottom:2em;padding-bottom:calc(5px + .91667vw);padding-top:calc(5px + .91667vw)}@media (min-width:1200px){._2LtWy{padding-bottom:16px;padding-top:16px}}._2G7HN{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._3ox9c,._3ox9c a,.wnyMH{color:#fff;text-decoration:none;font-size:calc(12px + .33333vw)}@media (min-width:1200px){._3ox9c,._3ox9c a,.wnyMH{font-size:16px}}._36cKf{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}._1qVSm{display:block;margin:48px auto 0;margin:3rem auto 0;width:140px}", ""]);

// exports
exports.locals = {
	"root": "_1fqjz",
	"subHeader": "_2LtWy",
	"subHeaderContent": "_2G7HN",
	"altTitle": "_3ox9c",
	"title": "wnyMH",
	"main": "_36cKf",
	"logo": "_1qVSm"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./node_modules/sass-loader/lib/loader.js!./src/components/Layout/Layout.scss
// module id = 636
// module chunks = 0 1 2 3 4 5 6 7 8 9 10